module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAYAAABCfffNAAAA4klEQVRIie2UvQ2CUBRGDy+WxljSUFAYV2AA4wIOQEHDCCb2xGkcwDiAI0AsLGwsCTiAxXtEfBK4arQgnO5evsPv5TphFAPMgC2wACY8KIADsAZOvNLp+Z57csIongNHYNpwkoocCICs1hN7Ckg6gpjjidUTewr9qBKWVi32FM/vso2xVYs9JQx+xd8uUgizN6sWewo9zxL2Vi32FLBBz3MbucnVEXsKSNE/2g4orVBp+oHJ1RF5vuemI9PMgFXHXTWR+Z7b6fVrhH9O9U0+XvXny3VY9Y0Mq35Y9fCO159VfwfFw1pC1aDJ8wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_Apps.png
// module id = 3m31
// module chunks = 1